import Vue from 'vue';
import Vuex from 'vuex';
import createProxyModule from 'vuex-proxy-module';
import game from '@/store/game';
import global from '@/store/global/';
import sound from '@/store/sound/';
import tutorial from '@/store/tutorial/';

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		game,
		global,
		sound,
		tutorial,
	},
	actions: {
		assetLoad({ dispatch, rootGetters }, file) {
			const music = rootGetters["sound/randomFile"]({ id: "main_loop" });

			if (file.id === music.id) {
				dispatch("sound/music/play", { id: "main_loop" });
			}
		},
	},
	plugins: [
		createProxyModule({
			path: "game/tutorial/steps/active",
			proxyPath: (rootState, rootGetters) => {
				const active = rootGetters["game/tutorial/steps/active"];
				return active ? `game/tutorial/steps/${active.id}` : false;
			},
		}),
		createProxyModule({
			path: "game/chapters/active",
			proxyPath: (rootState, rootGetters) => {
				const active = rootGetters["game/chapters/active"];
				return active ? `game/chapters/${active.id}` : false;
			},
		}),
		createProxyModule({
			path: "game/curveballs/active",
			proxyPath: (rootState, rootGetters) => {
				const active = rootGetters["game/curveballs/active"];
				return active ? `game/curveballs/${active.id}` : false;
			},
		}),
	],
});



// WEBPACK FOOTER //
// ./src/store/index.js